/**
 * Estruturas clássicas de texto de anúncio, como opção do assistente de IA.
 *
 * São perguntas em sequência, não fórmulas mágicas: nenhuma "vence" por
 * padrão, e o modelo pode não usar nenhuma (`livre`). O que cada uma NÃO
 * pode fazer também está escrito — urgência inventada, promessa de resultado,
 * depoimento fictício — porque é aí que anúncio é reprovado e cliente perde
 * confiança.
 */

export type AbordagemCopy = "livre" | "aida" | "pas" | "bab" | "fab" | "ppp";

export const ABORDAGENS_COPY: Record<AbordagemCopy, { label: string; descricao: string; instrucao: string }> = {
  livre: {
    label: "Deixar a IA escolher",
    descricao: "O modelo escolhe a estrutura que melhor serve ao post e ao objetivo.",
    instrucao: "Escolha a estrutura que melhor serve ao conteúdo; não force nenhuma.",
  },
  aida: {
    label: "Atenção → Interesse → Desejo → Ação",
    descricao: "Gancho que chama atenção, um detalhe que interessa, o benefício que faz querer, o próximo passo.",
    instrucao:
      "Estruture como AIDA: (1) uma abertura que chama atenção sem sensacionalismo nem urgência inventada; (2) um detalhe relevante do que está sendo oferecido; (3) o benefício aprovado que liga esse detalhe ao que a pessoa quer; (4) um convite claro à ação que descreva exatamente o que acontece ao tocar.",
  },
  pas: {
    label: "Problema → Agitação → Solução",
    descricao: "Nomeia uma dor real, mostra a consequência sem exagero, apresenta a oferta como saída.",
    instrucao:
      "Estruture como Problema–Agitação–Solução: (1) um problema real e plausível para esse público; (2) a consequência dele, sem medo, vergonha ou exagero; (3) como a oferta resolve, com os limites honestos. Nunca invente dor nem prometa resultado.",
  },
  bab: {
    label: "Antes → Depois → Ponte",
    descricao: "Situação atual, situação desejada (plausível, não garantida), e o que liga uma à outra.",
    instrucao:
      "Estruture como Antes–Depois–Ponte: (1) a situação atual, descrita com respeito; (2) a situação desejada, plausível e sem garantia; (3) o mecanismo aprovado que leva de uma à outra. Sem transformação irreal nem prazos inventados.",
  },
  fab: {
    label: "Característica → Vantagem → Benefício",
    descricao: "Bom para produto e curso: o que é, o que isso permite, o que a pessoa ganha.",
    instrucao:
      "Estruture como Característica–Vantagem–Benefício: (1) uma característica verificável da oferta; (2) a vantagem concreta que ela dá; (3) o benefício para a pessoa, sem inventar resultado. Sem comparação com concorrente e sem jargão.",
  },
  ppp: {
    label: "Promessa → Prova → Próximo passo",
    descricao: "Só quando há prova real (número, depoimento autorizado, credencial).",
    instrucao:
      "Estruture como Promessa–Prova–Próximo passo: (1) uma promessa limitada e sustentável; (2) uma prova citável com precisão (número, credencial, depoimento AUTORIZADO — se o briefing não trouxer prova, não invente: use uma característica verificável no lugar); (3) o próximo passo, sem pressão.",
  },
};
